import * as React from 'react';
import * as Sentry from '@sentry/nextjs';
import copy from 'copy-to-clipboard';
import toast from 'react-hot-toast';
import Copy from 'svg/Copy';
import FaceBookIcon from 'svg/FaceBookIcon';
import LinkedInIcon from 'svg/LinkedInIcon';
import XIcon from 'svg/XIcon';
import { generateShareUrls } from 'utils/shared/blog/generateShareUrls';
import classNames from 'styles/utils/classNames';

interface Props {
  articleUrl: string;
  articleTitle: string;
  articleDescription?: string;
  className?: string;
}

export default function ShareArticle({ articleUrl, articleTitle, className }: Props) {
  const shareUrls = generateShareUrls(articleUrl, articleTitle);

  const handleCopyLink = () => {
    try {
      copy(articleUrl);
      toast.success('Link copied to clipboard');
    } catch (error) {
      Sentry.captureException(error);
      toast.error('Could not copy link');
    }
  };

  const handleSocialShare = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer,width=600,height=600');
  };

  return (
    <div className={classNames('flex items-center gap-1', className)}>
      <button
        onClick={handleCopyLink}
        className="rounded-full p-2 transition-colors hover:bg-color-bg-lightmode-secondary dark:hover:bg-color-bg-darkmode-secondary"
        aria-label="Copy link"
      >
        <Copy className="h-5 w-5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
      </button>

      <button
        onClick={() => handleSocialShare(shareUrls.facebook)}
        className="rounded-full p-2 transition-colors hover:bg-color-bg-lightmode-secondary dark:hover:bg-color-bg-darkmode-secondary"
        aria-label="Share on Facebook"
      >
        <FaceBookIcon className="h-5 w-5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
      </button>

      <button
        onClick={() => handleSocialShare(shareUrls.twitter)}
        className="rounded-full p-2 transition-colors hover:bg-color-bg-lightmode-secondary dark:hover:bg-color-bg-darkmode-secondary"
        aria-label="Share on X"
      >
        <XIcon className="h-5 w-5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
      </button>

      <button
        onClick={() => handleSocialShare(shareUrls.linkedin)}
        className="rounded-full p-2 transition-colors hover:bg-color-bg-lightmode-secondary dark:hover:bg-color-bg-darkmode-secondary"
        aria-label="Share on LinkedIn"
      >
        <LinkedInIcon className="h-5 w-5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
      </button>
    </div>
  );
}
